import React, { Component } from "react";

class SectionFooter extends Component {
  render() {
    return (
      <div className="row no-bottom-margin">
        <a className="back-to-top-fix" href="#main">
          Zurück nach Oben
        </a>
      </div>
    );
  }
}
export default SectionFooter;



// WEBPACK FOOTER //
// ./src/components/sectionfooter.js